import React from 'react';

export default class ErrorMsg extends React.Component {
	render() {
		return (
			<div className="content__form-errmsg">
				<div className="content__form-errmsg-item content__form-errmsg-item--visible">
					{this.props.error_msg}
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./app/components/common_components/ErrorMsg.js